export default __webpack_public_path__ + "static/media/trash.e425f011.svg";